import { gsap } from 'gsap'

export const toggleFooterAccordion = (bool, content, icon) => {
    gsap.to(content, {
        height: bool ? 'auto' : 0,
        duration: .3
    })

    gsap.to(icon, {
        rotate: bool ? 45 : 0
    })
}